module.exports = __webpack_public_path__ + "img/tribe-mythic.9ffc824b.svg";